import 'slick-carousel'

$(document).ready(function(){
  $('.subscriptions-carousel').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 300,
    arrows: false,
    centerMode: false,
    variableWidth: true,
    infinite: true,
    dots: true,
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.subscriptions-carousel').removeClass('d-none')
});
